import React from "react";
import { Toaster as Sonner } from "sonner";
import {
    CheckCircle,
    Info,
    Loader2,
    XCircle,
    AlertTriangle,
} from "lucide-react";

const Toaster = ({ ...props }) => {
    return (
        <Sonner
            theme="light"
            className="toaster group"
            closeButton
            toastOptions={{
                classNames: {
                    toast:
                        "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
                    description: "group-[.toast]:text-muted-foreground",
                    actionButton:
                        "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
                    cancelButton:
                        "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
                },
            }}
            icons={{
                success: <CheckCircle className="h-4 w-4 text-green-500" />,
                info: <Info className="h-4 w-4 text-blue-500" />,
                warning: <AlertTriangle className="h-4 w-4 text-yellow-500" />,
                error: <XCircle className="h-4 w-4 text-red-500" />,
                loading: <Loader2 className="h-4 w-4 animate-spin" />,
            }}
            {...props}
        />
    );
};

export { Toaster };